import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext'; // Hent AuthProvider
import Layout from './components/Layout';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClassManagementPage from './pages/ClassManagementPage';
import ExaminerProfilePage from './pages/ExaminerProfilePage';
import StaffPage from './pages/StaffPage';
import ContactsPage from './pages/ContactsPage';
import OrganisationsPage from './pages/OrganisationsPage';
import LanguageCentersPage from './pages/LanguageCentersPage';
import OutgoingAllocationPage from './pages/OutgoingAllocationPage';
import IncomingAllocationPage from './pages/IncomingAllocationPage';
import MyExamsPage from './pages/MyExamsPage';
import MyCensorDataPage from './pages/MyCensorDataPage';
import MyAppointmentPage from './pages/MyAppointmentPage';
import UserManagementPage from './pages/UserManagementPage';
import ResetPasswordPage from './pages/ResetPasswordPage';



import './App.css';

// En wrapper der beskytter ruter (Routes)
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          {/* Beskyttede Ruter */}
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/classes" element={<ProtectedRoute><ClassManagementPage /></ProtectedRoute>} />
          <Route path="/contacts" element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
          <Route path="/staff" element={<ProtectedRoute><StaffPage /></ProtectedRoute>} />
          <Route path="/organisations" element={<ProtectedRoute><OrganisationsPage /></ProtectedRoute>} />
          <Route path="/language-centers" element={<ProtectedRoute><LanguageCentersPage /></ProtectedRoute>} />
          <Route path="/allocation/outgoing" element={<ProtectedRoute><OutgoingAllocationPage /></ProtectedRoute>} />
          <Route path="/allocation/incoming" element={<ProtectedRoute><IncomingAllocationPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ExaminerProfilePage /></ProtectedRoute>} />
          <Route path="/my-exams" element={<ProtectedRoute><MyExamsPage /></ProtectedRoute>} />
          <Route path="/my-censor-data" element={<ProtectedRoute><MyCensorDataPage /></ProtectedRoute>} />
          <Route path="/my-appointment" element={<ProtectedRoute><MyAppointmentPage /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><UserManagementPage /></ProtectedRoute>} />
          

          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;